<template>
  <div class="orderm-continner">
    <div class="header-title">订单中心</div>
    <div class="sub-continner">
      <div class="person-card-content-second">
        <div
          id="allorder"
          class="item-second-content selected"
          @click="
            queryOrderNumberWithStatus('全部');
            changeSeletorStyle($event);
          "
        >
          {{ orderNumbers.totalOrderNumbers }}
          <div>全部</div>
        </div>
        <div class="line-area"></div>
        <div
          id="readyorder"
          class="item-second-content"
          @click="
            queryOrderNumberWithStatus('超时发货');
            changeSeletorStyle($event);
          "
        >
          {{ orderNumbers.areadyAppealOrderNumber }}
          <div>超时发货</div>
        </div>
        <div class="line-area"></div>
        <div
          id="readyordert"
          class="item-second-content"
          @click="
            queryOrderNumberWithStatus('申诉审核中');
            changeSeletorStyle($event);
          "
        >
          {{ orderNumbers.reviewAppealOrderNumber }}
          <div>申诉中</div>
        </div>
        <div class="line-area"></div>
        <div
          id="unpassorder"
          class="item-second-content"
          @click="
            queryOrderNumberWithStatus('审核未通过');
            changeSeletorStyle($event);
          "
        >
          {{ orderNumbers.reviewUnAppealOrderNumber || 0 }}
          <div>申诉失败</div>
        </div>
        <div class="line-area"></div>
        <div
          id="unpassorder"
          class="item-second-content"
          @click="
            filterRefundableOrders();
            changeSeletorStyle($event);
          "
        >
          {{ orderNumbers.rebackMoneyOrders || 0 }}
          <div>可退款</div>
        </div>
        <div class="line-area"></div>
        <div
          id="backmoneyorder"
          class="item-second-content"
          @click="
            queryOrderNumberWithStatus('已退款');
            changeSeletorStyle($event);
          "
        >
          {{ orderNumbers.payCommisionOrderNumber || 0 }}
          <div>已赔付</div>
        </div>
        <div class="line-area"></div>
        <div
          id="backmoneyorder"
          class="item-second-content"
          @click="
            queryOrderNumberWithStatus('已退款');
            changeSeletorStyle($event);
          "
        >
          {{ orderNumbers.payForOrderNumber }}
          <div>已退款</div>
        </div>
      </div>
      <div class="main-card">
        <div class="main-card-content">
          提示：显示申诉完成并通过订单和佣金！
          <div v-show="false">
            养号：点击准备中的要养的账号，选中点开始养号！
          </div>
        </div>
      </div>
      <!--<van-field
        readonly
        clickable
        name="picker"
        :value="value"
        label="类型"
        placeholder="全部"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="timeValue"
        label="时间范围"
        placeholder="默认显示全部"
        @click="showCalendar = true"
      />
       <van-calendar
        v-model="showCalendar"
        type="range"
        :min-date="minDate"
        @confirm="onCalConfirm"
        @unselect="unSelect"
      />-->

      <div class="main-list">
        <!--<div class="main-list-opertion">
          <van-button
            type="info"
            size="small"
            style="margin-bottom: 5px;margin-right: 10px;"
            @click="batchOperation"
          >
            批量操作
          </van-button>
        </div>-->
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
              <van-cell
              v-for="(item, index) in displayList"
              :key="item.orderNumbers || index"
              :title="item.title"
              :label="item.label"
            >
              <template #title>
                <span style="font-size: x-small;"
                  >订单编号：
                  <span  v-on:click="copyOrderNumber(item.orderNumbers)">{{
                    item.orderNumbers
                  }}</span></span
                >
              </template>
              <template #default>
                本金：<span
                  style="font-size:xx-small;color: red; margin-right: 10px;"
                  >{{ item.money }}</span
                >
                佣金：<span style="font-size:xx-small;color: red">{{
                  item.commission
                }}</span>
                <div>平台抽佣:<span style="font-size:xx-small;color: red; margin-left: 10px;">{{ item.serviceMoney }}</span></div>
                <div style="margin-top: 5px;">
                  <img
                    v-if="item.goodImgUrl"
                    :src="item.goodImgUrl"
                    style="width: 45px; height: 45px; object-fit: cover; border-radius: 4px;"
                    alt="商品图片"
                  />
                </div>
              </template>
              <template #label>
                下单状态：<span style="color: red;font-size: 12px !important;"
                  >{{ item.statusName }}
                  <span
                    style="font-size: 11px !important;padding-left: 5px;white-space: nowrap;color: hsl(237, 80%, 63%);"
                    v-if="item.statusName == '申诉审核中'"
                    @click="queryOrderProgress(item)"
                    >查询进度</span
                  >
                  <span
                    style="font-size: 11px !important;padding-left: 5px;white-space: nowrap;color: hsl(237, 80%, 63%);"
                    v-if="item.status == '202211240001'"
                    @click="changeOrderStatus(item)"
                    >点击申诉</span
                  >
                  <span
                    style="font-size: 11px !important;padding-left: 5px;white-space: nowrap;color: hsl(237, 80%, 63%);"
                    v-else-if="
                      item.status == '202109010002' ||
                        item.status == '202509130001'
                    "
                    @click="refundingLoading ? null : changeOrderStatus(item)"
                    :style="refundingLoading ? 'opacity: 0.5; pointer-events: none;' : ''"
                    >点击退款</span
                  >
                </span>
                <div style="font-size: x-small;">接单时间：<br>{{ item.createTime }}</div>
                <div style="font-size: x-small;">
                  商品链接：{{ item.thumbUrl }}
                </div>
                <div class="time_div" v-if="item.status == '202109010001'">
                  <div style="display: inline-block;">申诉计时:</div>
                  <div style="display: inline-block;margin-left: 2px;">
                    <van-count-down
                      :time="item.timeRange * 60 * 1000"
                      format="DD 天 HH 时 mm 分 ss 秒"
                      @finish="changeStatuWithCount(5, item)"
                    />
                  </div>
                </div>
                <div class="time_div" v-if="item.status == '202305250002'">
                  <div style="display: inline-block;">发货倒计时:</div>
                  <div style="display: inline-block;margin-left: 2px;">
                    <van-count-down
                      :time="item.waitSendTimeRange * 60 * 1000"
                      format="DD 天 HH 时 mm 分 ss 秒"
                      @finish="changeStatuWithCount(3, item)"
                    />
                  </div>
                </div>
                <!-- <div style="font-size: x-small;" v-if="item.status == '202109010001'">成功率(申诉成功的概率): <span style="color: #f55033;">{{item.appealRate}}%</span></div> -->
              </template>
            </van-cell>
          </van-list>
        <!-- </van-pull-refresh> -->
      </div>
    </div>
    <van-popup v-model="showDialogPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConDialogfirm"
        @cancel="showDialogPicker = false"
      />
    </van-popup>

    <!--新增判断发起退款的确认-->
    <van-dialog
      v-model="showBackMoneyDialog"
      title="申请退款"
      @confirm="requestBackMoney"
      :before-close="refundDialogBeforeClose"
      show-cancel-button
      class="reason-select-dialog"
      style="text-align: center"
    >
      <div class="appeal-reason-row">
        <span class="appeal-reason-label">退款理由：</span>
        <div class="appeal-reason-drop">
          <div
            class="appeal-select-control"
            @click="showRefundDropdown = !showRefundDropdown"
          >
            <span
              class="appeal-select-text"
              :class="{ 'appeal-placeholder': !reason }"
              >{{ reason || "请选择退款理由" }}</span
            >
            <van-icon
              :name="showRefundDropdown ? 'arrow-up' : 'arrow-down'"
              class="appeal-select-arrow"
            />
          </div>
          <!-- 下拉选项以浮层方式弹出，不改动弹窗自身高度 -->
          <div v-if="showRefundDropdown" class="appeal-options">
            <div
              v-for="opt in refundOptions"
              :key="opt.value"
              class="appeal-option"
              :class="{ active: opt.value === reason }"
              @click="selectRefundOption(opt)"
            >
              {{ opt.text }}
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <!--end-->

    <van-dialog
      v-model="showReasonDialog"
      title="申诉理由"
      @confirm="addReason"
      :before-close="reasonDialogBeforeClose"
      show-cancel-button
      class="reason-select-dialog"
      style="text-align: center"
    >
      <div class="appeal-reason-row">
        <span class="appeal-reason-label">申诉理由：</span>
        <div class="appeal-reason-drop">
          <div
            class="appeal-select-control"
            @click="showAppealDropdown = !showAppealDropdown"
          >
            <span
              class="appeal-select-text"
              :class="{ 'appeal-placeholder': !reason }"
              >{{ reason || "请选择申诉理由" }}</span
            >
            <van-icon
              :name="showAppealDropdown ? 'arrow-up' : 'arrow-down'"
              class="appeal-select-arrow"
            />
          </div>
          <!-- 下拉选项以浮层方式弹出，不改动弹窗自身高度 -->
          <div v-if="showAppealDropdown" class="appeal-options">
            <div
              v-for="opt in appealOptions"
              :key="opt.value"
              class="appeal-option"
              :class="{ active: opt.value === reason }"
              @click="selectAppealOption(opt)"
            >
              {{ opt.text }}
            </div>
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="showOrderProgressDialog" :show-confirm-button="false">
      <template #title>
        <div
          style="display: flex;justify-content: space-between;align-items: center;padding: 0 16px;line-height: 24px;"
        >
          <div>申诉进度</div>
          <div
            style="color: #f55033;cursor: pointer;"
            @click="showOrderProgressDialog = false"
          >
            X
          </div>
        </div>
      </template>
      <div style="max-height: 320px;overflow-y: scroll;padding: 12px 16px;text-align: left;">
        <van-steps direction="vertical" :active="orderProgressActive">
          <van-step v-for="(st, idx) in orderProgressList" :key="idx">
            <div class="pr-row">
              <div class="pr-time">{{ st.time }}</div>
              <div class="pr-main">
                <div class="pr-title">{{ st.title }}</div>
                <div v-if="st.desc" class="pr-desc">{{ st.desc }}</div>
              </div>
            </div>
          </van-step>
        </van-steps>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  getTaskOrders,
  changeOrderStatusApi,
  queryOrdersNum,
} from "../../api/system/mobile_taskorder";
import { Toast, Dialog } from "vant";
export default {
  name: "orderm",
  data() {
    return {
      queryForm: {},
      value: "",
      columns: [
        "全部",
        "待发货",
        "超时发货",
        "申诉审核中",
        "申诉完成",
        "退款审核中",
        "已退款",
        "已完成",
      ],
      minDate: new Date(2025, 0, 1),
      showPicker: false,
      showCalendar: false,
      timeValue: "",
      refreshing: false,
      loading: false,
      finished: false,
      startTime: "",
      endTime: "",
      dataList: [],
      selectOrder: {},
      showDialogPicker: false,
      showBackMoneyDialog: false,
      orderNumbers: {},
      isMounted: false,
      showReasonDialog: false,
      showAppealDropdown: false,
      appealOptions: [
        { text: "缺货/不发货/拒绝发货", value: "缺货/不发货/拒绝发货" },
      ],
      showRefundDropdown: false,
      reason: "",
      showOrderProgressDialog: false,
      orderProgressList: [],
      orderProgressActive: 0,
      showRefundableOnly: false,
      refundingLoading: false, // 退款中loading状态
      refundableCount: 0,  // 可退款数量，独立存储，不受 tab 切换影响
      pagination: {
        pageNum: 0,
        pageSize: 20,
        total: null,
      },
      requestSeq: 0,
    };
  },
  mounted() {
    this.$emit("titleChange", "订单");
    if (!this.isMounted) {
      this.getOrderNumbers();
      this.isMounted = true;
      this.refreshRefundableCount();
    }
  },
  computed: {
    // 退款理由只保留一个：根据当前订单 reviewIsPass 字段返回对应的一条
    refundOptions() {
      const order = this.selectOrder || {};
      const text =
        order.reviewIsPass === true || order.reviewIsPass === "true"
          ? "申诉（客服介入）已通过，要求退还本金及补偿！"
          : "申诉失败，申请全额退还本金！";
      return [{ text, value: text }];
    },
    // 计算属性获取可退款的订单数量（只读，无副作用）
    filteredOrders() {
      return this.dataList.filter(
        (order) => order.status === "202109010002" || order.status === "202509130001"
      ).length;
    },
    // 根据筛选状态返回实际展示的列表
    displayList() {
      if (this.showRefundableOnly) {
        return this.dataList.filter(
          (order) => order.status === "202109010002" || order.status === "202509130001"
        );
      }
      return this.dataList;
    },
  },
  methods: {
    getOrderNumbers(){
      // 调用全局统计接口，刷新所有顶部状态数字
      queryOrdersNum().then((res) => {
        if (res.success) {
          // 直接替换整个对象，确保所有字段都是最新值
          // 注意：如果后端返回的可退款字段名为空，由 refreshRefundableCount 独立计算
          this.orderNumbers = Object.assign({}, res.data);
          // 如果后端返回了可退款字段，直接用；否则保持独立计算的 refundableCount
          if (res.data.refundableCount !== undefined) {
            this.refundableCount = Number(res.data.refundableCount) || 0;
          }
        }
      });
    },
    // 独立刷新可退款数量——始终拉全部订单计算，不受当前 tab 影响
    refreshRefundableCount() {
      var self = this;
      getTaskOrders(1, "", "", { pageNum: 1, pageSize: 500 }).then(function (res) {
        if (res.success && res.data && res.data.records) {
          self.refundableCount = res.data.records.filter(function (order) {
            return order.status === "202109010002" || order.status === "202509130001";
          }).length;
        }
      });
    },
    async copyOrderNumber(text) {
      // console.log("复制订单号：", text);
       try {
        // 核心 API：this.$copyText(文本).then(...)
        await this.$copyText(text)
        Toast.success('✅ 复制成功！')
      } catch (e) {
        Toast.fail('❌ 复制失败！')
      }
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
      this.getData();
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onCalConfirm(date) {
      let [start, end] = date;
      this.timeValue = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      this.showCalendar = false;
      this.startTime = this.formatDate(start);
      this.endTime = this.formatDate(end);
      this.getData();
    },
    changeSeletorStyle(e) {
      document
        .querySelectorAll(".item-second-content")
        .forEach((el) => el.classList.remove("selected"));
      e.currentTarget.classList.toggle("selected");
    },
    queryOrderNumberWithStatus(status) {
      this.showRefundableOnly = false;
      this.value = status;
      this.getData();
      // 切换 tab 后刷新顶部统计数字
      this.getOrderNumbers();
    },
    filterRefundableOrders() {
      // 先在已有数据上立即启用可退款筛选，避免切换时出现空白页
      this.showRefundableOnly = true;
      this.value = '全部';
      // 后台重新拉取全部订单数据刷新列表
      this.getData();
      // 切换 tab 后刷新可退款数量（只在需要时拉取，不在 getData 里每次都拉）
      this.refreshRefundableCount();
    },
    getData() {
      let tmpStatus = 1;
      switch (this.value) {
        case "全部":
          tmpStatus = 1;
          break;
        case "待发货":
          tmpStatus = 2;
          break;
        // case "复活":
        //   tmpStatus = 3;
        //   break;
        case "超时发货":
          tmpStatus = 3;
          break;
        case "申诉审核中":
          tmpStatus = 4;
          break;
        case "申诉完成":
          tmpStatus = 5;
          break;
        case "退款审核中":
          tmpStatus = 6;
          break;
        case "已退款":
          tmpStatus = 7;
          break;
        case "已超时":
          tmpStatus = 8;
          break;
        case "审核未通过":
          tmpStatus = 9;
          break;
      }
      // 切换标签时重置分页状态
      this.pagination.pageNum = 1;
      this.finished = false;
      this.dataList = [];
      // 置 loading 为 true，防止 van-list 在 getData 期间并发触发 onLoad
      this.loading = true;

      const seq = ++this.requestSeq;
      return getTaskOrders(tmpStatus, this.startTime, this.endTime, this.pagination)
        .then((res) => {
          // 防止旧请求污染：只有最新发出的请求才更新数据
          if (seq !== this.requestSeq) return;
          if (res.success) {
            console.log(" --", res.data);
            this.dataList = res.data.records;
            // 数据全部加载完毕则标记 finished，防止 van-list 重复触发 onLoad
            if (
              this.dataList.length >= res.data.total ||
              (this.showRefundableOnly &&
                this.dataList.filter(
                  (o) =>
                    o.status === "202109010002" ||
                    o.status === "202509130001"
                ).length >= this.refundableCount)
            ) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {
          if (seq !== this.requestSeq) return;
          Toast.fail(err.message);
        })
        .finally(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
    },
    changeStatuWithCount(status, order) {
      this.pagination.pageNum = 1;
      changeOrderStatusApi({
        orderId: order.orderId,
        status: status,
      })
        .then((res) => {
          if (res.success) {
            this.getData();
            this.getOrderNumbers();
          }
        })
        .catch((err) => {
          Toast.fail(err.message);
        });
    },
    onLoad() {
      if (this.finished) return;

      // 可退款筛选模式下，若已加载的可退款订单数已达到总数，停止翻页
      if (this.showRefundableOnly) {
        const refundableInList = this.dataList.filter(
          (o) => o.status === "202109010002" || o.status === "202509130001"
        ).length;
        if (refundableInList >= this.refundableCount) {
          this.finished = true;
          this.loading = false;
          return;
        }
      }

      this.pagination.pageNum = this.pagination.pageNum + 1;
      this.loading = true;

      let tmpStatus = 1;
      switch (this.value) {
        case "全部":
          tmpStatus = 1;
          break;
        case "已下单":
          tmpStatus = 2;
          break;
        // case "复活":
        //   tmpStatus = 3;
        //   break;
        case "超时发货":
          tmpStatus = 3;
          break;
        case "申诉审核中":
          tmpStatus = 4;
          break;
        case "申诉完成":
          tmpStatus = 5;
          break;
        case "退款审核中":
          tmpStatus = 6;
          break;
        case "已退款":
          tmpStatus = 7;
          break;
        case "已超时":
          tmpStatus = 8;
          break;
        case "审核未通过":
          tmpStatus = 9;
          break;
      }

      const seq = ++this.requestSeq;
      getTaskOrders(tmpStatus, this.startTime, this.endTime, this.pagination)
        .then((res) => {
          // 防止旧请求污染：只有最新发出的请求才更新数据
          if (seq !== this.requestSeq) return;
          if (res.success) {
            console.log("-2-", res.data);
            if (res.data.records.length > 0) {
              this.dataList.push(...res.data.records);
            }
            if (this.dataList.length >= res.data.total) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {
          if (seq !== this.requestSeq) return;
          Toast.fail(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      if (!this.finished) {
        this.pagination.pageNum = this.pagination.pageNum + 1;
      }
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    unSelect() {
      this.startTime = null;
      this.endTime = null;
    },
    requestBackMoney() {
      if (!this.reason) {
        return;
      }
      this.refundingLoading = true;
      // 乐观更新：立即将可退款计数减1，防止 getData() 刷新后因 displayList
      // 为空但 refundableCount 仍为旧值，导致 van-list 循环翻页到底
      if (this.showRefundableOnly && this.refundableCount > 0) {
        this.refundableCount = this.refundableCount - 1;
      }
      Toast.loading({
        message: '退款中，请等待',
        forbidClick: true,
        duration: 0,
      });
      changeOrderStatusApi({
        orderId: this.selectOrder.orderId,
        status: 6,
      })
        .then((res) => {
          if (res.success) {
            return this.getData().then(() => {
              // 同步顶部状态数字（会重新拉取准确的 refundableCount）
              this.getOrderNumbers();
            });
          }
        })
        .catch((err) => {
          Toast.fail(err.message);
        })
        .finally(() => {
          this.refundingLoading = false;
          Toast.clear();
        });
    },
    queryOrderProgress(order) {
      this.selectOrder = order;
      const name = order.statusName || "";
      // 根据 statusName 文本判断客服判决结果：
      // 成立(通过/退款/完成/可退款/赔付) / 不成立(不通过/失败/审核未通过) / 空=平台核实处理中
      let verdict = "";
      if (
        name.indexOf("完成") != -1 ||
        name.indexOf("通过") != -1 ||
        name.indexOf("退款") != -1 ||
        name.indexOf("赔付") != -1 ||
        name == "可退款"
      ) {
        verdict = "成立";
      } else if (
        name.indexOf("不通过") != -1 ||
        name.indexOf("失败") != -1 ||
        name == "审核未通过"
      ) {
        verdict = "不成立";
      }
      // 申诉计时(分钟)：换算成预计处理天数，并用于计算客服裁决时间
      const minutes = Number(order.timeRange) || 0;
      const days = minutes > 0 ? Math.ceil(minutes / 60 / 24) : 0;
      const parseTime = (str) => {
        if (!str) return null;
        const d = new Date(String(str).replace(/-/g, "/"));
        return isNaN(d.getTime()) ? null : d;
      };
      const fmtTime = (d) => {
        if (!d) return "";
        const p = (n) => (n < 10 ? "0" + n : "" + n);
        return (
          d.getFullYear() +
          "-" +
          p(d.getMonth() + 1) +
          "-" +
          p(d.getDate()) +
          " " +
          p(d.getHours()) +
          ":" +
          p(d.getMinutes()) +
          ":" +
          p(d.getSeconds())
        );
      };
      // 申诉提起时间 / 平台核实开始时间 = statusChangeTime
      const startTime = parseTime(order.statusChangeTime || order.createTime);
      const statusTime = fmtTime(startTime);
      // 投诉理由：优先 remarks，兼容其它可能字段名
      const reasonText =
        order.remarks ||
        order.remark ||
        order.appealRemarks ||
        order.appealReason ||
        order.complaintReason ||
        order.reason ||
        "";
      // 客服裁决时间 = statusChangeTime + 申诉计时时长
      const judgeTime =
        minutes > 0 && startTime
          ? fmtTime(new Date(startTime.getTime() + minutes * 60 * 1000))
          : "";
      const lastStep =
        verdict == "成立"
          ? {
              title: "投诉成立",
              desc:
                "平台将会对您赔付现金，此次卖家违约行为已计入店铺考核(包含但不限于对店铺进行警告、扣分、降权等处罚)。",
            }
          : verdict == "不成立"
          ? {
              title: "投诉不成立",
              desc: "您的本金会正常返回。",
            }
          : { title: "平台客服判决", desc: "等待平台客服判决…" };
      this.orderProgressList = [
        {
          title: "你发起了投诉",
          desc: "申诉理由：" + (reasonText || ""),
          time: statusTime,
        },
        {
          title: "平台核实处理中",
          desc: days > 0 ? "预计 " + days + " 天处理完成" : "",
          time: statusTime,
        },
        Object.assign({}, lastStep, { time: judgeTime }),
      ];
      this.orderProgressActive = verdict ? 2 : 1;
      this.showOrderProgressDialog = true;
    },
    selectAppealOption(opt) {
      this.reason = opt.value;
      this.showAppealDropdown = false;
    },
    reasonDialogBeforeClose(action, done) {
      if (action === "confirm" && !this.reason) {
        Toast("请选择申诉理由");
        // 必须调用 done(false)：清除确定按钮的 loading(转圈)，同时不关闭弹窗
        done(false);
        return;
      }
      done();
    },
    selectRefundOption(opt) {
      this.reason = opt.value;
      this.showRefundDropdown = false;
    },
    refundDialogBeforeClose(action, done) {
      if (action === "confirm" && !this.reason) {
        Toast("请选择退款理由");
        // 必须调用 done(false)：清除确定按钮的 loading(转圈)，同时不关闭弹窗
        done(false);
        return;
      }
      done();
    },
    addReason() {
      if (!this.reason) {
        return;
      }
      changeOrderStatusApi({
        orderId: this.selectOrder.orderId,
        status: 4,
        remarks: this.reason,
      })
        .then((res) => {
          if (res.success) {
            this.getData();
            // 同步顶部状态数字
            this.getOrderNumbers();
          }
        })
        .catch((err) => {
          Toast.fail(err.message);
        });
    },
    changeOrderStatus(order) {
      console.log(order);
      if (order.status == "202211240001") {
        this.selectOrder = order;
        this.reason = "";
        this.showAppealDropdown = false;
        this.showReasonDialog = true;
      } else if (
        order.status == "202109010002" ||
        order.status == "202509130001"
      ) {
        this.selectOrder = order;
        this.reason = "";
        this.showRefundDropdown = false;
        this.showBackMoneyDialog = true;
      } else {
        Dialog.confirm({
          title: "切换订单状态",
          message: `请确认要切换当前订单状态吗？`,
        })
          .then(() => {
            // on confirm
            this.showDialogPicker = true;
            this.selectOrder = order;
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    onConDialogfirm(val) {
      let tmpStatus = 1;
      switch (val) {
        case "全部":
          tmpStatus = 1;
          break;
        case "已下单":
          tmpStatus = 2;
          break;
        // case "复活":
        //   tmpStatus = 3;
        //   break;
        case "超时发货":
          tmpStatus = 3;
          break;
        case "申诉审核中":
          tmpStatus = 4;
          break;
        case "申诉完成":
          tmpStatus = 5;
          break;
        case "退款审核中":
          tmpStatus = 6;
          break;
        case "已退款":
          tmpStatus = 7;
          break;
        case "已超时":
          tmpStatus = 8;
          break;
      }
      changeOrderStatusApi({
        orderId: this.selectOrder.orderId,
        status: tmpStatus,
      })
        .then((res) => {
          if (res.success) {
            this.getData();
          }
        })
        .catch((err) => {
          Toast.fail(err.message);
        });
      this.showDialogPicker = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../root.scss";
.orderm-continner {
  background-color: rgb(249, 249, 249);
  background-image: url(../../assets/img/thembg.png);
  background-repeat: no-repeat;
  background-size: contain;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  bottom: calc(50px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
}

.sub-continner {
  flex: 1;
  min-height: 0;
  margin-top: 10;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-title,
.person-card-content-second,
.main-card {
  flex-shrink: 0;
}

.main-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

::v-deep .van-count-down {
  color: #f55033;
}

::v-deep .van-cell__title {
  width: 55%;
}

/* 弹窗内的表单标签按内容自适应宽度，避免占据过宽导致理由显示不全 */
::v-deep .van-dialog .van-cell__title.van-field__label {
  flex: 0 0 auto;
  width: auto;
}

/* 申诉/退款理由行：统一舒适高度，内容垂直居中，保证弹窗宽高比协调 */
.appeal-reason-row {
  display: flex;
  align-items: center;
  min-height: 96px;
  padding: 16px;
  box-sizing: border-box;
}

.appeal-reason-label {
  flex: 0 0 auto;
  margin-right: 10px;
  font-size: 14px;
  color: #646566;
  white-space: nowrap;
}

.appeal-reason-drop {
  flex: 1;
  min-width: 0;
  position: relative;
}

.appeal-select-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  padding: 0 10px;
  border-radius: 6px;
  background: #f7f8fa;
  box-sizing: border-box;
}

.appeal-select-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #323233;
}

.appeal-select-text.appeal-placeholder {
  color: #969799;
}

.appeal-select-arrow {
  flex: 0 0 auto;
  margin-left: 6px;
  font-size: 14px;
  color: #969799;
}

/* 退款/申诉理由下拉：以浮层方式从选择框下方弹出，不改动弹窗自身高度。
   因 .van-dialog 默认 overflow:hidden 会把超出弹窗的下拉裁掉，
   故对这两个带 reason-select-dialog 的弹窗放开 overflow，让下拉可以悬浮显示 */
::v-deep .reason-select-dialog {
  overflow: visible;
}

/* 放开 overflow 后，弹窗默认主题下通栏的白色底部按钮不会再被卡片裁成圆角，
   底部会变成直角。这里让 footer 自己把内容裁成与卡片一致的底部圆角，
   顶/底保持同样圆角 */
::v-deep .reason-select-dialog .van-dialog__footer {
  overflow: hidden;
  border-radius: 0 0 16px 16px;
}

.appeal-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 40;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #ebedf0;
  box-shadow: 0 2px 12px rgba(100, 101, 102, 0.2);
  overflow: hidden;
}

.appeal-option {
  padding: 11px 10px;
  font-size: 14px;
  color: #323233;
  text-align: left;
}

.appeal-option.active {
  color: #f55033;
}

.appeal-option:active {
  background: #f7f8fa;
}

.van-cell span,
.van-cell div {
  font-size: calculeResultFontSize(false, 2px) !important;
}

.time_div div {
  font-size: 12px !important;
}

.item-second-content {
  color: #ffffff;
}

.selected {
  color: #f55033;
}

/* 申诉进度步骤内容（不改 van-steps 自身样式） */
.pr-row {
  display: flex;
  align-items: flex-start;
}

.pr-time {
  flex: 0 0 96px;
  padding-right: 6px;
  font-size: 11px;
  line-height: 18px;
  color: #969799;
  text-align: right;
  box-sizing: border-box;
}

.pr-main {
  flex: 1;
  min-width: 0;
}

.pr-title {
  font-size: 14px;
  line-height: 18px;
  word-break: break-all;
}

.pr-desc {
  font-size: 12px;
  line-height: 16px;
  color: #969799;
  margin-top: 2px;
  word-break: break-all;
}
</style>
